export default "__VITE_ASSET__f9be6013__"